// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__PWuEP","disabled":"FileBtn_disabled__do3-0","warn":"FileBtn_warn__1HksR","fade":"FileBtn_fade__34W8i"};